export default {
      id: "clock-usage",
      viewBox: "0 0 23 28",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#clock-usage",
      toString: function () {
        return this.url;
      }
    }